export const IMPORT_CHECKLIST = [
  "leads.restrictions.fileExtension",
  "leads.restrictions.headerRow",
  "leads.restrictions.columnRestriction",
  "leads.restrictions.objectTypes",
  "leads.restrictions.contact",
  "leads.restrictions.assignTo",
  "leads.restrictions.tags",
];
